import {
  CompanyService,
  CompanyServiceApiResponse,
  CompanyServiceListApiResponse,
  CreateCompanyServicePayload,
  CreateCompanyServiceApiResponse,
  UpdateCompanyServicePayload,
  UpdateCompanyServiceApiResponse,
  DeleteCompanyServiceApiResponse,
  ServiceTag,
  InitializeAdsPricesApiResponse,
  AdPriceComponentListApiResponse,
  AdPriceComponentSingleApiResponse,
  AdPriceComponentBatchApiResponse,
  UpdateAdPriceComponentPayload,
  UpdateAdPriceComponentsPayload,
} from "@/types/company_services";
import { axiosWithToken } from "@/utils/axios";
import { AxiosResponse } from "axios";

class CompanyServiceService {
  // ─── Services ────────────────────────────────────────────────

  getService(id: string): Promise<AxiosResponse<CompanyServiceApiResponse>> {
    return axiosWithToken().get(`/company-services/${id}`);
  }

  getServiceByServiceId(
    serviceId: string,
  ): Promise<AxiosResponse<CompanyServiceApiResponse>> {
    return axiosWithToken().get(`/company-services/code/${serviceId}`);
  }

  getAllServices(): Promise<AxiosResponse<CompanyServiceListApiResponse>> {
    return axiosWithToken().get("/company-services");
  }

  getServicesByTag(
    tag: ServiceTag,
  ): Promise<AxiosResponse<CompanyServiceListApiResponse>> {
    return axiosWithToken().get("/company-services", { params: { tag } });
  }

  createService(
    payload: CreateCompanyServicePayload,
  ): Promise<AxiosResponse<CreateCompanyServiceApiResponse>> {
    return axiosWithToken().post("/company-services", payload);
  }

  updateService(
    id: string,
    payload: UpdateCompanyServicePayload,
  ): Promise<AxiosResponse<UpdateCompanyServiceApiResponse>> {
    return axiosWithToken().put(`/company-services/${id}`, payload);
  }

  deleteService(
    id: string,
  ): Promise<AxiosResponse<DeleteCompanyServiceApiResponse>> {
    return axiosWithToken().delete(`/company-services/${id}`);
  }

  initializeAdsPrices(): Promise<
    AxiosResponse<InitializeAdsPricesApiResponse>
  > {
    return axiosWithToken().post("/company-services/initialize-ads-prices");
  }

  // ─── Ad Price Components ─────────────────────────────────────

  getAdPriceComponents(): Promise<
    AxiosResponse<AdPriceComponentListApiResponse>
  > {
    return axiosWithToken().get("/company-services/ad-price-components");
  }

  updateAdPriceComponent(
    id: string,
    payload: UpdateAdPriceComponentPayload,
  ): Promise<AxiosResponse<AdPriceComponentSingleApiResponse>> {
    return axiosWithToken().put(
      `/company-services/ad-price-components/${id}`,
      payload,
    );
  }

  updateAdPriceComponents(
    payload: UpdateAdPriceComponentsPayload,
  ): Promise<AxiosResponse<AdPriceComponentBatchApiResponse>> {
    return axiosWithToken().put(
      "/company-services/ad-price-components/batch",
      payload,
    );
  }
}

const CompanyServiceServiceInstance = new CompanyServiceService();
export default CompanyServiceServiceInstance;
